import { createContext } from "react";

const AllCategoriesContext = createContext();

export default AllCategoriesContext;
